<div *ngIf="toolTipData.ciType === ciTypes.Test">
    <div class="head-bold preserve-space" [innerHTML]="toolTipData.text | highlight: [searchTexts.globalSearch]"></div>
    <hr class="line-style">
    <div>
        <span>{{'vbeiTechnicalDescriptionOfTest' | translate}}</span> &nbsp;
        <span class="head-bold"
            [innerHTML]="'[' + toolTipData.testCode + ']' | highlight: [searchTexts.globalSearch]"></span>
    </div>
    &nbsp;
    <div>
        <table>
            <tbody>
                <tr *ngIf="toolTipData.comment && toolTipData.comment !== ' '">
                    <th id="technical-description-Comment-label">{{'vbeiComments'| translate}}</th>
                    <td id="technical-description-Comment-value"
                        [innerHTML]="toolTipData.comment | highlight: [searchTexts.globalSearch, searchTexts.comments]">
                    </td>

                </tr>
                <tr *ngIf="toolTipData.localisedName">
                    <th id="technical-description-name-label">{{'vbeiName' | translate}}</th>
                    <td id="technical-description-name-value"
                        [innerHTML]="toolTipData.localisedName | highlight: [searchTexts.globalSearch]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.instruction">
                    <th id="technical-description-instructions-label">{{'vbeiInstructions' | translate}}</th>
                    <td id="technical-description-instructions-value"
                        [innerHTML]="toolTipData.instruction | highlight: [searchTexts.globalSearch, searchTexts.comments]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.description">
                    <th id="technical-description-description-label">{{'vbeiDescription'| translate}}</th>
                    <td id="technical-description-description-value"
                        [innerHTML]="toolTipData.description | highlight: [searchTexts.globalSearch, searchTexts.description]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.applicableOn">
                    <th id="technical-description-applicableOn-label">{{'vbeiApplicableOn' | translate}}</th>
                    <td id="technical-description-applicableOn-value"
                        [innerHTML]="toolTipData.applicableOn | highlight: [searchTexts.globalSearch, searchTexts.applicableOn]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.method">
                    <th id="technical-description-method-label">{{'vbeiMethod' | translate}}</th>
                    <td id="technical-description-method-value"
                        [innerHTML]="toolTipData.method | highlight: [searchTexts.globalSearch, searchTexts.method]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.objective">
                    <th id="technical-description-objective-label">{{'vbeiObjective' | translate}}</th>
                    <td id="technical-description-objective-value"
                        [innerHTML]="toolTipData.objective | highlight: [searchTexts.globalSearch, searchTexts.objective]">
                    </td>
                </tr>

                <tr *ngIf="toolTipData.memberTests && toolTipData.memberTests.length > 0">
                    <th id="technical-cluster-Contains-label">{{'vbeiContains' | translate}}</th>
                    <td id="technical-cluster-Contains-value">
                        <ng-container *ngFor="let testCluster of toolTipData.memberTests index as i">
                            <div>
                                <span class="head-bold"
                                    [innerHTML]="'[' + testCluster.code + ']' | highlight: [searchTexts.globalSearch]"></span>
                                &nbsp;
                                <span
                                    [innerHTML]="testCluster.localisedName | highlight: [searchTexts.globalSearch]"></span>
                            </div>
                        </ng-container>
                    </td>
                </tr>
                <tr>
                </tr>
            </tbody>
        </table>
        <table *ngIf="toolTipData.parameters && toolTipData.parameters.length>0">
            <th>{{'vbei_AR_PARAMETER' | translate}}</th>
            <th>
                <div *ngIf="isDisplayHoverLOD()">{{'vbeiLOD' | translate}}</div>
            </th>
            <th>
                <div *ngIf="isDisplayHoverLOQ()">{{'vbeiLOQ' | translate}}</div>
            </th>
            <th>
                <div *ngIf="isDisplayHoverCASNumber()">{{'vbeiCASNumber' | translate}}</div>
            </th>
            <ng-container *ngFor="let parameter of toolTipData.parameters; index as i">
                <tr>
                    <td>
                        <span class="head-bold"
                            [innerHTML]="'[' + parameter.code + ']' | highlight: [searchTexts.globalSearch, searchTexts.parameterCode]"></span>
                        &nbsp;
                        <span
                            [innerHTML]="parameter.localisedName | highlight: [searchTexts.globalSearch, searchTexts.parameterName]"></span>

                    </td>
                    <td>
                        <div *ngIf="parameter.lod">{{parameter.lod}}
                            {{parameter.daqNumerator.name}}/{{parameter.daqDenominator.name}}</div>
                    </td>
                    <td>
                        <div *ngIf="parameter.loq">{{parameter.loq}}
                            {{parameter.daqNumerator.name}}/{{parameter.daqDenominator.name}}</div>
                    </td>
                    <td>
                        <div *ngIf="parameter.casIdentifier"
                            [innerHTML]="parameter.casIdentifier | highlight: [searchTexts.globalSearch, searchTexts.CASNumber]">
                        </div>
                    </td>
                </tr>
            </ng-container>
        </table>
    </div>
</div>
<div *ngIf="toolTipData.ciType === ciTypes.Package || toolTipData.ciType === ciTypes.TestBundle">
    <div class="head-bold preserve-space" [innerHTML]="toolTipData.text | highlight: [searchTexts.globalSearch]"></div>
    <div class="head-bold" [innerHTML]="toolTipData.additionalColumn9 | highlight: [searchTexts.globalSearch]"></div>
    <hr class="line-style">
    <div>
        <span *ngIf='toolTipData.ciType === ciTypes.Package'>{{'vbeiTechnicalDescriptionOfPackage' | translate}}</span> &nbsp;
        <span *ngIf='toolTipData.ciType === ciTypes.TestBundle'>{{'vbeiTechnicalDescriptionOfTestBundle' | translate}}</span> &nbsp;
        <span class="head-bold"
            [innerHTML]="'[' + toolTipData.packageCode + ']' | highlight: [searchTexts.globalSearch, searchTexts.description]"></span>
    </div>
    &nbsp;
    <div>
        <table>
            <tbody>
                <tr>
                    <th id="technical-description-name-label">{{'vbeiName' | translate}}</th>
                    <td id="technical-description-name-value"
                        [innerHTML]="toolTipData.localisedName | highlight: [searchTexts.globalSearch]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.instruction">
                    <th id="technical-description-instructions-label">{{'vbeiInstructions' | translate}}</th>
                    <td id="technical-description-instructions-value"
                        [innerHTML]="toolTipData.instruction | highlight: [searchTexts.globalSearch, searchTexts.comments]">
                    </td>
                </tr>
                <tr *ngIf="toolTipData.applicableOn">
                    <th id="technical-description-applicableOn-label">{{'vbeiApplicableOn' | translate}}</th>
                    <td id="technical-description-applicableOn-value"
                        [innerHTML]="toolTipData.applicableOn | highlight: [searchTexts.globalSearch, searchTexts.applicableOn]">
                    </td>
                </tr>
                <tr>
                    <th id="technical-Package-Contains-label">{{'vbeiContains' | translate}}</th>
                    <td id="technical-Package-Contains-value">
                        <ng-container *ngFor="let test of toolTipData.tests; index as i">
                            <div>
                                <span class="head-bold"
                                    [innerHTML]="'[' + test.code + ']' | highlight: [searchTexts.globalSearch]"></span>
                                &nbsp;
                                <span [innerHTML]="test.localisedName | highlight: [searchTexts.globalSearch]"></span>
                            </div>
                        </ng-container>
                    </td>
                </tr>
                <tr>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div *ngIf="toolTipData.ciType === ciTypes.Subgroup" class="sub-group-header">
    <div id="quotation-content" class="qtip-content-table">
        <div class="tooltip-content-title">
            <h3 class="preserve-space" [innerHTML]="toolTipData.name | highlight: [searchTexts.globalSearch]"></h3>
        </div>
        <h3 class="sub-group-code" [innerHTML]="toolTipData.comlimsCode | highlight: [searchTexts.globalSearch]"></h3>
        <ul style="padding-left: 60px;">
            <li *ngFor="let ciItem of toolTipData.ciItems" style="margin-top: 10px;">
                <div *ngIf="ciItem.testCode else package">
                    <span class="item-code head-bold"
                        [innerHTML]="'[' + ciItem.testCode + ']' | highlight: [searchTexts.globalSearch]"></span>&nbsp;
                    <div class="preserve-space" [innerHTML]="ciItem.text | highlight: [searchTexts.globalSearch]"></div>
                    <ul *ngFor="let testCluster of ciItem.memberTests" style="margin-top: 5px;">
                        <li><span class="item-code"
                                [innerHTML]="'[' + testCluster.code + ']' | highlight: [searchTexts.globalSearch]"></span>&nbsp;
                            <span class="preserve-space"
                                [innerHTML]="testCluster.localisedName | highlight: [searchTexts.globalSearch]"></span>
                        </li>
                    </ul>
                </div>
                <ng-template #package>
                    <span class="item-code head-bold"
                        [innerHTML]="'[' + ciItem.packageCode + ']' | highlight: [searchTexts.globalSearch]"></span>&nbsp;
                    <div class="preserve-space" [innerHTML]="ciItem.text | highlight: [searchTexts.globalSearch]"></div>
                    <ul *ngFor="let test of ciItem.tests" style="margin-top: 5px;">
                        <li><span class="item-code"
                                [innerHTML]="'[' + test.code + ']' | highlight: [searchTexts.globalSearch]"></span>&nbsp;
                            <span class="preserve-space"
                                [innerHTML]="test.localisedName | highlight: [searchTexts.globalSearch]"></span></li>
                        <ul *ngFor="let testCluster of test.memberTests" style="margin-top: 5px;">
                            <li><span class="item-code"
                                    [innerHTML]="'[' + testCluster.code + ']' | highlight: [searchTexts.globalSearch]"></span>&nbsp;
                                <span class="preserve-space"
                                    [innerHTML]="testCluster.localisedName | highlight: [searchTexts.globalSearch]"></span>
                            </li>
                        </ul>
                    </ul>
                </ng-template>
            </li>
        </ul>
    </div>
</div>